import { h } from "preact";

import { getValue, renderHtml } from "../../helpers";
import i18n from "../../i18n";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";

export default {
  health_insurance_obtained: ({ answers, product, onNext, onRestart }) => {
    const company = getValue(answers.healthInsuranceCompany);
    const companyName = product.name;
    const date = getValue(answers.healthInsuranceStart);

    let text = i18n.t("pages.health_insurance.success");
    if (company !== "unknown") {
      text = i18n.t("pages.health_insurance.success_with_company", {
        company: companyName,
      });
      if (date) {
        text = i18n.t(
          "pages.health_insurance.success_with_company_and_start_date",
          { company: companyName, date }
        );
      }
    } else if (date) {
      text = i18n.t("pages.health_insurance.success_with_start_date", { date });
    }

    return (
      <section class="task-page">
        <HeaderIcon>health_insurance</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem overline="Health Insurance">{renderHtml(text)}</ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  health_insurance_not_obtained: ({ answers, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>health_insurance</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem overline="Health Insurance">
              {renderHtml(i18n.t("pages.health_insurance.missing"))}
            </ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onRestart}>New search</Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
